export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_17-cbca00a81812e0de366ea06c78ea2039.jpg";